<template>
    <p style="
        color: var(--color-white);
        font-size: 14px;
        height: 22px;
        position: relative;
        white-space: nowrap;
    "
    @mouseover="underline = true"
    @mouseleave="underline = false"
    >{{ name.toUpperCase() }}</p>
    <div v-if="underline || active"
    style="
        height: 0px;
        width: 100%;
        border-bottom-width: 1px;
        border-bottom-color: var(--color-white);
    "></div>
</template>

<script>

export default {
    props: ["name", "active"],
    data: () => ({
        underline: false
    }),

    methods: {
    
    }
}

</script>

<style lang="scss" scoped>
</style>